import styled from "styled-components";

export const FormContainer = styled.div`
    max-width: 540px;
    margin: 0 auto;
    color: #333333;
    font-family: 'Univers';
`;

export const FormFooter = styled.div`
    margin-top: 15px;
`;
